export const adminRichTextLinkUpdater = (str: string): string => {
  const linkRegex = /<a([^>]*?)title="button"([^>]*?)>(.*?)<\/a>/g;
  return str.replace(linkRegex, (match, prefix, suffix, text) => {
    return `<a${prefix}title="button"${suffix} class="btn__primary-1"><span class='text'>${text}</span></a>`;
  });
};
